<template>
  <div :class="[
    'sidebar-area position-fixed start-0 top-0 bg-gray h-100vh transition',
    { active: stateStoreInstance.open },
    
  ]" :style="{paddingTop: notificationMessage ? '40px' : '0'}" id="sidebar-area">
    <div class="logo position-absolute start-0 end-0 top-0 bg-gray duration-500 " :style="{paddingTop: notificationMessage ? '70px' : '30px'}">
      <router-link to="/" class="d-flex align-items-center text-white text-decoration-none">
        <!--  login proproxy  -->
        <template v-if="name === 'proproxy'">
          <img src="../../assets/logo1.png" alt="logo-icon" class="w-12 proimg aspect-ratio m-0" />
          <span class="fw-bold ms-10 flex text-black"><p class="text-blue-400">Pro</p>Proxies</span>
        </template>
        <!--  Global Proproxy   -->
        <template v-if="name === 'global'">
          <img v-if="isDarkMode" src="../../assets/logo2.png" alt="logo-icon" class="globalimg w-[150px] aspect-ratio mx-auto " />
          <img v-else src="../../assets/logo.png" alt="logo-icon" class=" globalimg aspect-ratio mx-auto w-[150px]" />
        </template>
        <!--   Proxy Heros   -->
        <template v-if="name === 'heros'">
          <img v-if="isDarkMode" src="../../assets/logo4.png" alt="logo-icon" class="globalimg w-[150px] aspect-ratio mx-auto " />
          <img v-else src="../../assets/logo3.png" alt="logo-icon" class=" globalimg aspect-ratio mx-auto w-[150px]" />
        </template>
        <!--  proxy test  -->
        <template v-if="name === 'test'">
          <img src="../../assets/logo5.png" alt="logo-icon" class="w-12 proimg aspect-ratio m-0" />
          <span class="fw-bold ms-10 flex text-black">Dashboard</span>
        </template>
        <!--  proxy fella  -->
        <template v-if="name === 'fella'">
          <img src="../../assets/logo6.jpg" alt="logo-icon" class="w-12 proimg aspect-ratio m-0" />
          <span class="fw-bold ms-10 flex text-black">ProxyFella</span>
        </template>
        <!--  Global katana   -->
        <template v-if="name === 'katana'">
          <img src="../../assets/logo7.png" alt="logo-icon" class="globalimg w-[90px] aspect-ratio mx-auto " />
        </template>
        <!--  proxy Ps proxy tech  -->
        <template v-if="name === 'psproxytech'">
          <img v-if="isDarkMode" src="../../assets/logo9.png" alt="logo-icon" class="globalimg w-[180px] aspect-ratio" />
          <img v-else src="../../assets/logo8.png" alt="logo-icon" class="globalimg w-[180px] aspect-ratio" />
        </template>
        <!--  proxy ProxyStyler  -->
        <template v-if="name === 'proxystyler'">
          <img v-if="isDarkMode" src="../../assets/logo10.png" alt="logo-icon" class="globalimg w-[180px] aspect-ratio" />
          <img v-else src="../../assets/logo10.png" alt="logo-icon" class="globalimg w-[180px] aspect-ratio" />
        </template>
        <!--  proxy ProxyGo  -->
        <template v-if="name === 'proxygo'">
          <img v-if="isDarkMode" src="../../assets/logo11.png" alt="logo-icon" class="globalimg w-[180px] aspect-ratio" />
          <img v-else src="../../assets/logo12.png" alt="logo-icon" class="globalimg w-[180px] aspect-ratio" />
        </template>
      </router-link>
      <div class="border-bottom" style="padding-top: 15px;"></div>
      <button class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
        @click="stateStoreInstance.onChange">
        <i class="ph-duotone ph-caret-double-right"></i>

      </button>
    </div>
    <div class="sidebar-menu" v-if="user.role==='admin'">
      <ul class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion" id="sidebarNavAccordion">
        <li class="sidebar-nav-item">
          <router-link to="/admin/server" class="sidebar-nav-link  d-block">
            <i class="flaticon-list"></i>
            <span class="title">Server</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/proxystock" class="sidebar-nav-link  d-block">
            <i class="flaticon-list"></i>
            <span class="title">Proxy Stock</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/proxy" class="sidebar-nav-link d-block">
            <i class="flaticon-cubes"></i>
            <span class="title">Proxy</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/disconnectedproxy" class="sidebar-nav-link d-block">
            <v-icon icon="mdi-minus-circle"></v-icon>
            <span class="title">Disconnected Proxy</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/license" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-license"></v-icon>
            <span class="title">License</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/package" class="sidebar-nav-link  d-block">
            <i class="flaticon-document"></i>
            <span class="title">Package</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/coupon" class="sidebar-nav-link  d-block">
            <i class="fa fa-money"></i>
            <span class="title">Coupon</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item" v-if="name === 'global' || name === 'proxygo'">
          <router-link to="/admin/new-location" class="sidebar-nav-link  d-block">
            <i class="fa fa-map-pin"></i>
            <span class="title">New Location</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/customer" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-account-multiple"></v-icon>
            <span class="title">Customer</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/transaction" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-swap-horizontal"></v-icon>
            <span class="title">Transaction</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/reseller" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-account-key"></v-icon>
            <span class="title">Reseller</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/referrer" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-account-tie"></v-icon>
            <span class="title">Affiliate program</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/invitedusers" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-account-multiple-plus"></v-icon>
            <span class="title">Invited users</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/account" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-account"></v-icon>
            <span class="title">Account</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/configuration" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-cog-outline"></v-icon>
            <span class="title">Configuration</span>
          </router-link>
        </li>
        <!-- <li class="sidebar-nav-item">
          <router-link to="/admin/country" class="sidebar-nav-link  d-block">
            <i class="fa fa-flag"></i>
            <span class="title">Locations</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/isp" class="sidebar-nav-link  d-block">
            <i class="fa fa-signal"></i>
            <span class="title">ISP</span>
          </router-link>
        </li> -->
        <li v-if="name !== 'fella'" class="sidebar-nav-item">
          <router-link to="/admin/chat" class="sidebar-nav-link  d-block ">
            <v-icon icon="mdi-message-text"></v-icon>
            <div class="flex flex-row justify-between">
            <span class="title">Messages</span>
            <span v-if="unreadCount !== 0 " class=" z-10 text-[12px] w-[25px] min-w-[25px] badge rounded-pill flex bg-danger items-center justify-center aspect-square ">{{unreadCount}}</span>
            </div>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/apikey" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-key"></v-icon>
            <span class="title">API Key</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/faq" class="sidebar-nav-link  d-block">
            <i class="fa fa-question-circle"></i>
            <span class="title">FAQ</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/admin/siteinfo" class="sidebar-nav-link  d-block">
            <i class="fa fa-info-circle"></i>
            <span class="title">Site Information</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <button @click="signOut" class="sidebar-nav-link d-block">
            <i class="flaticon-logout"></i>
            <span class="title">Logout</span>
          </button>
        </li>
      </ul>
    </div>
    <div class="sidebar-menu" v-else>
      <ul class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion" id="sidebarNavAccordion">
        <li class="sidebar-nav-item">
          <router-link to="/buy-new-proxy" class="sidebar-nav-link  d-block">
            <i class="flaticon-widget"></i>
            <span class="title">Buy New Proxy</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/my-proxy" class="sidebar-nav-link d-block">
            <i class="flaticon-cubes"></i>
            <span class="title">My Proxy</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/bitcart" class="sidebar-nav-link d-block">
            <i class="flaticon-money"></i>
            <span class="title">Deposit / Transactions</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/account" class="sidebar-nav-link d-block">
            <i class="flaticon-user"></i>
            <span class="title">Account</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/referral" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-account-tie"></v-icon>
            <span class="title">Affiliate program</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item" v-if="name === 'global' || name === 'proxygo'">
          <router-link to="/gift-code" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-gift"></v-icon>
            <span class="title">Gift code</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/apikey" class="sidebar-nav-link  d-block">
            <v-icon icon="mdi-key"></v-icon>
            <span class="title">API Key</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <router-link to="/faq" class="sidebar-nav-link  d-block">
            <i class="fa fa-question-circle"></i>
            <span class="title">FAQ</span>
          </router-link>
        </li>
        <li class="sidebar-nav-item">
          <button @click="signOut" class="sidebar-nav-link d-block">
            <v-icon icon="mdi-account"></v-icon>
            <span class="title">Logout</span>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script  setup>
import stateStore from "../../utils/store";

import { useAccountStore } from "@/stores";
import { storeToRefs } from "pinia";
const accountStore = useAccountStore()
import { useDarkModeStore } from "@/stores";
const stateStoreInstance = stateStore;
import { computed, watch, onMounted, onBeforeUnmount } from "vue";
import { useChatStore } from "@/stores/chat.store";
import notifySound from "@/assets/notify.mp3";
import { createNotificationPlayer } from "@/helpers/notification-player";
const darkStore = useDarkModeStore();
const {isDarkMode} = storeToRefs(darkStore);
const name = process.env.VUE_APP_VUE_NAME

const chatStore = useChatStore();
let chatUnreadPoller = null;
let unreadInitialized = false;
let unreadCount = computed(() => Number(chatStore.unreadCount || 0));

const {user, unread, notificationMessage} = storeToRefs(accountStore)
const playMessageSound = createNotificationPlayer(notifySound, { maxQueue: 5 });
const refreshChatUnread = async () => {
  if (user.value?.role === 'admin') {
    const previousCount = unreadCount.value;
    const nextCount = await chatStore.loadUnreadCount();
    if (unreadInitialized && nextCount > previousCount) {
      playMessageSound(nextCount - previousCount);
    }
    unreadInitialized = true;
    return;
  }
  unreadInitialized = false;
};

watch(user, () => {
  unreadInitialized = false;
  chatStore.clear();
  refreshChatUnread();
})

const signOut = () => {
  unreadInitialized = false;
  chatStore.clear();
  accountStore.signout()
}

onMounted(() => {
  refreshChatUnread();
  chatUnreadPoller = setInterval(refreshChatUnread, 4000);
});

onBeforeUnmount(() => {
  if (chatUnreadPoller) clearInterval(chatUnreadPoller);
});



</script>